import { Injectable, Signal, computed } from '@angular/core';
import { injectLeafActivatedRoute } from 'ngxtension/inject-leaf-activated-route';
import type { SuggestContext } from '../agent.types';

/**
 * Global route-based context for the agent chat.
 * Reads the deepest ActivatedRoute (via ngxtension) and exposes `jobId` / `workOrderId` params as signals.
 * Relies on `paramsInheritanceStrategy: 'always'` (configured app-wide), so leaf params include all ancestors'.
 */
@Injectable({ providedIn: 'root' })
export class AgentContextService {

  private readonly leafRoute = injectLeafActivatedRoute();

  public readonly $currentJobId: Signal<string | undefined> = computed(() => this.leafRoute().snapshot.params['jobId']);

  public readonly $currentWorkOrderId: Signal<string | undefined> = computed(() => this.leafRoute().snapshot.params['workOrderId']);

  public readonly $context: Signal<SuggestContext> = computed(() => {

    if (this.$currentWorkOrderId()) return 'workOrder';
    if (this.$currentJobId()) return 'job';
    return 'default';
  });
}
